/* eslint import/no-webpack-loader-syntax: off */
/* eslint import/no-named-default: off */
import React from 'react';
import _ from '@dh-fe/translate';
import FormattedMoney from 'components/FormattedMoney/FormattedMoney';
import classnames from 'classnames';

import Image from 'components/Image/Image';
import { isMobile } from 'utils/device-detect';
import { getPrizes } from 'pages/AchievementLeaders/components/FindOutMore/FindOutMore.content';
import FirstPrizeOranum from 'pages/AchievementLeaders/components/FindOutMore/assets/1stPrizeOranum.png';
import SecondPrizeOranum from 'pages/AchievementLeaders/components/FindOutMore/assets/2ndPrizeOranum.png';
import ThirdPrizeOranum from 'pages/AchievementLeaders/components/FindOutMore/assets/3rdPrizeOranum.png';
import FirstPrizeOranumWebp from 'pages/AchievementLeaders/components/FindOutMore/assets/1stPrizeOranum.webp';
import SecondPrizeOranumWebp from 'pages/AchievementLeaders/components/FindOutMore/assets/2ndPrizeOranum.webp';
import ThirdPrizeOranumWebp from 'pages/AchievementLeaders/components/FindOutMore/assets/3rdPrizeOranum.webp';
import SignUpButton from 'components/Button/SignUpButton';
import bgDesktopJpg2x from './assets/TopExpertsBkg@2x.jpg';
import bgDesktopWebp2x from './assets/TopExpertsBkg@2x.webp';
import bgDesktopJpg from './assets/TopExpertsBkg.jpg';
import bgDesktopWebp from './assets/TopExpertsBkg.webp';
import bgMobileJpg2x from './assets/TopExpertsBkgMobile@2x.jpg';
import bgMobileWebp2x from './assets/TopExpertsBkgMobile@2x.webp';
import bgMobileJpg from './assets/TopExpertsBkgMobile.jpg';
import bgMobileWebp from './assets/TopExpertsBkgMobile.webp';

import styles from './TopExpertsContest.module.scss';

const TopExpertsContest = () => {
    const prizes = getPrizes();

    return (
        <section className={styles.topExpertsContest}>
            <div className={styles.gradient} />
            <Image
                unCompressed={isMobile() ? bgMobileJpg : bgDesktopJpg}
                unCompressed2x={isMobile() ? bgMobileJpg2x : bgDesktopJpg2x}
                webp={isMobile() ? bgMobileWebp : bgDesktopWebp}
                webp2x={isMobile() ? bgMobileWebp2x : bgDesktopWebp2x}
                alt={_`Top Experts Contest`}
                className={styles.background}
                lazy={false}
            />

            <div className={styles.content}>
                <div className={styles.columns}>
                    <div className={classnames(styles.column, styles.columnShort)}>
                        <div className={classnames(styles.columnImageContainer, styles.secondPrize)}>
                            <Image unCompressed={SecondPrizeOranum} webp={SecondPrizeOranumWebp} alt="cash" />
                        </div>
                        <div className={styles.award}>{prizes.second.award}</div>
                        <div className={styles.iconContainer}>
                            <div className={styles.iconDivider} />
                            <img src={prizes.second.icon} alt="cash" />
                            <div className={styles.iconDivider} />
                        </div>
                    </div>
                    <div className={classnames(styles.column, styles.columnTall)}>
                        <div className={classnames(styles.columnImageContainer, styles.firstPrize)}>
                            <Image unCompressed={FirstPrizeOranum} webp={FirstPrizeOranumWebp} alt="cash" />
                        </div>
                        <div className={styles.award}>{prizes.first.award}</div>
                        <div className={styles.iconContainer}>
                            <div className={styles.iconDivider} />
                            <img src={prizes.first.icon} alt="cash" />
                            <div className={styles.iconDivider} />
                        </div>
                    </div>
                    <div className={classnames(styles.column, styles.columnShort)}>
                        <div className={classnames(styles.columnImageContainer, styles.thirdPrize)}>
                            <Image unCompressed={ThirdPrizeOranum} webp={ThirdPrizeOranumWebp} alt="cash" />
                        </div>
                        <div className={styles.award}>{prizes.third.award}</div>
                        <div className={styles.iconContainer}>
                            <div className={styles.iconDivider} />
                            <img src={prizes.third.icon} alt="cash" />
                            <div className={styles.iconDivider} />
                        </div>
                    </div>
                </div>

                <div className={styles.rightSide}>
                    <h2>{_`Top Experts Contest`}</h2>
                    <h1>
                        {_`We are giving away up to [b]{amount}[/b] in prizes every month!`.parseBB().toJSX({
                            amount: <FormattedMoney amount={5_000} precision={0} currency="usd" />,
                        })}
                    </h1>
                    <p>{_`Every dollar earned increases your chances to win the amazing prizes!`}</p>

                    <SignUpButton className={styles.button} />
                </div>
            </div>
        </section>
    );
};

export default TopExpertsContest;
